import { ANSWER_LABEL, CADENCE_LABEL, eventLabelFrom, statusText } from './watch-format.js';

const HELD = new Set(['queued', 'held-digest', 'held-ceiling', 'sending', 'delayed', 'failed-retrying']);
const FAILED = new Set(['failed', 'bounced', 'complained', 'rejected']);

/** The four buckets the Status filter offers. */
export function statusBucket(status) {
  if (status === 'sent' || status === 'delivered') return 'delivered';
  if (HELD.has(status)) return 'held';
  if (FAILED.has(status)) return 'failed';
  return 'suppressed';
}

function liveRow(r, catalog) {
  return {
    id: `live:${r.notificationId}`,
    source: 'live',
    when: r.createdAt,
    recipient: r.displayName ?? r.address,
    address: r.address,
    event: r.kind === 'digest' ? `Digest, ${r.lines ?? 0} ${r.lines === 1 ? 'line' : 'lines'}` : eventLabelFrom(catalog, r.catalogId),
    cadence: CADENCE_LABEL[r.cadence] ?? r.cadence,
    status: statusText(r),
    bucket: statusBucket(r.status),
    audiences: r.audiences ?? [],
    answer: r.answer ? (ANSWER_LABEL[r.answer] ?? r.answer) : null,
  };
}

function dailyRow(h, i, ruleLabel) {
  const events = (h.events ?? []).map((e) => `${ruleLabel(e.eventId)} x${e.count}`).join(', ');
  return {
    id: `daily:${h.sentAt}:${i}`,
    source: 'daily',
    when: h.sentAt,
    recipient: `${h.sent} ${h.sent === 1 ? 'recipient' : 'recipients'}`,
    address: null,
    event: h.isTest ? 'Test email' : (events || 'Daily email'),
    cadence: 'After each collection',
    status: h.isTest ? 'Test sent' : `${h.sent} sent`,
    bucket: 'delivered',
    audiences: [],
    answer: null,
  };
}

/** Watch notifications (`GET /watch/send-log`) and daily sends (`GET /notifications/history`), newest first. */
export function buildSendLogRows({ liveItems = [], history = [], catalog = null, ruleLabel = (id) => id } = {}) {
  return [...liveItems.map((r) => liveRow(r, catalog)), ...history.map((h, i) => dailyRow(h, i, ruleLabel))]
    .sort((a, b) => Date.parse(b.when) - Date.parse(a.when));
}
